import * as React from "react";

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M15.108 12.682c1.191-1.512 1.725-3.388 1.494-5.25-.23-1.864-1.21-3.577-2.74-4.798-1.53-1.22-3.5-1.859-5.513-1.786-2.015.072-3.925.849-5.35 2.176C1.574 4.35.74 6.128.664 8.002c-.076 1.875.61 3.706 1.924 5.13 1.313 1.422 3.155 2.331 5.158 2.545 2.002.213 4.018-.284 5.643-1.394h-.001c.037.046.076.09.12.132l4.738 4.407c.23.215.543.336.87.336.326 0 .64-.12.87-.335.231-.215.36-.506.361-.81 0-.304-.13-.595-.36-.81l-4.738-4.407a1.225 1.225 0 0 0-.141-.115v.001Zm.317-4.4c0 .826-.175 1.645-.515 2.41a6.287 6.287 0 0 1-1.467 2.042 6.82 6.82 0 0 1-2.195 1.365 7.208 7.208 0 0 1-2.59.48 7.208 7.208 0 0 1-2.59-.48 6.821 6.821 0 0 1-2.196-1.365 6.288 6.288 0 0 1-1.467-2.043 5.919 5.919 0 0 1-.515-2.41c0-1.67.713-3.271 1.982-4.452 1.27-1.18 2.99-1.844 4.786-1.844 1.795 0 3.516.663 4.785 1.844 1.27 1.181 1.982 2.783 1.982 4.453Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1={20.347}
        y1={-12.073}
        x2={20.405}
        y2={15.401}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#165FFC" />
        <stop offset={1} stopColor="#01A9EF" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgComponent;
